import { FC, useMemo } from 'react';
import { SidePanel } from '../../shared/modals/side-panel';
import { SidePanelLayout } from '../../shared/modals/side-panel-layout/side-panel-layout.component';
import {
    StyledHeader,
    StyledLineItem,
    StyledLineItemGrid,
    StyledLineItemValue,
    StyledModalContentContainer,
    StyledVehicleSummary,
} from './selected-leasing-summary-modal.styled';
import { ProductDetailsStore } from '../../../lib/state/hessel-site/product-details';
import { formatPrice } from '../../../utils/helpers';
import { Abbreviations } from '../../../constants/units-and-abbreviations';
import { GenericModalContentRender } from '../../shared/modals/modal-with-editor-content/generic-modal-content';
import { GenericModalContent } from '../../shared/modals/modal-with-editor-content/modal-with-editor-content.component';
import { SelectedTotalSummary } from './selected-total-summary/selected-total-summary.component';

export type SelectedLeasingStartupCostContent = {
    establishmentFeeLabel: string;
    establishmentFeeTooltip: string;
    returnFeeLabel: string;
    returnFeeTooltip: string;
    documentFeeLabel: string;
    documentFeeTooltip: string;
    insuranceOptOutFeeLabel: string;
    insuranceOptOutFeeTooltip: string;
};

type IProps = {
    onClose: () => void;
    visible: boolean;
    content: GenericModalContent;
    startupCostContent?: SelectedLeasingStartupCostContent;
};

export const SelectedLeasingSummaryModal: FC<IProps> = ({ onClose, visible, content, startupCostContent }) => {
    const { selectedProduct, optionalEquipmentPriceSum } = ProductDetailsStore.useStoreState((state) => state);

    const selectedEquipment = useMemo(() => {
        return selectedProduct?.optionalEquipment['HiRE Selected']?.filter((item) => item.isSelected);
    }, [selectedProduct?.optionalEquipment]);

    if (!selectedProduct) return null;

    return (
        <SidePanel cancelAction={onClose} isVisible={visible}>
            <SidePanelLayout closeSidePanel={onClose}>
                <StyledHeader>Din Hessel Selected aftale</StyledHeader>
                <StyledVehicleSummary>
                    {selectedProduct.brand} {selectedProduct.modelTitle} {selectedProduct.name}
                </StyledVehicleSummary>
                <StyledLineItemGrid>
                    <StyledLineItem>
                        Bilens pris
                        <StyledLineItemValue>
                            {formatPrice(selectedProduct.purchaseTypes.hireSelected.baseMonthlyPrice - optionalEquipmentPriceSum)}{' '}
                            {Abbreviations.KR_SLASH_MD}
                        </StyledLineItemValue>
                    </StyledLineItem>
                    {selectedEquipment?.map((item) => (
                        <StyledLineItem key={item.id}>
                            {item.name}
                            <StyledLineItemValue>
                                {formatPrice(item?.monthlyHireSelectedPrice || 0)} {Abbreviations.KR_SLASH_MD}
                            </StyledLineItemValue>
                        </StyledLineItem>
                    ))}
                </StyledLineItemGrid>
                <SelectedTotalSummary startupCostContent={startupCostContent} />
                <StyledModalContentContainer>
                    <GenericModalContentRender {...content} />
                </StyledModalContentContainer>
            </SidePanelLayout>
        </SidePanel>
    );
};
